import {useRef} from 'react';
import {useFormikContext} from 'formik';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import ExternalImagePopup from '../../../../../../component/imagePopup/externalImagePopup/ExternalImagePopup';
import TextEditor from '../../../../../../component/textEditor/TextEditor';
import ImageHeader from '../../../../../branding/imageHeader/ImageHeader';
import {uploadFile} from '../../../../../../redux/user/userActions';
import {defaultImage} from '../../../../../../assets/symbols/images/defaultImage';
import {givechakImage} from '../../../../../../assets/symbols/images/givechakImage';
import {TState} from '../../../../../../redux/store.type';
import * as css from './detailsStep.css';
import {SubscriptionFormValues} from '../../createSubscriptionForm.types';

function DetailsStep() {
    const {t} = useTranslation('subscriptions');
    const {values, setFieldValue} = useFormikContext<SubscriptionFormValues>();
    const type = useSelector((s: TState) => s.event.type);
    const uid = useSelector((s: TState) => s.user.uid);
    const widthWindowWidth = useSelector((s: TState) => s.ui.windowWidth);
    const imageSize = Math.min(Math.floor((widthWindowWidth - 20) / 3.94), 160);
    const defaultFallbackImage = type === 'givechak' ? givechakImage : defaultImage;
    const lang = useSelector((s: TState) => s.user.lang);
    const quillRef = useRef(null);

    const handleImageSave = async (newImage: any) => {
        if(newImage?.image) {
            const uploadedImage = await uploadFile(newImage.image, '', 'subscriptionImage', uid);
            if(uploadedImage) {
                setFieldValue('image', {
                    path: uploadedImage,
                    imageId: newImage.imageId || '',
                    creditName: newImage.credit?.creditName || '',
                    alt: newImage.credit?.alt || '',
                    license: newImage.credit?.license || ''
                });
            }
        } else {
            setFieldValue('image', null);
        }
    };

    const imageEditorProps = {
        size: {width: imageSize, height: imageSize},
        image: values.image?.path || defaultImage,
        imageId: values.image?.imageId?.toString() || '',
        setImage: handleImageSave,
    };

    const creditProps = {
        creditName: values.image?.creditName || '',
        alt: values.image?.alt || '',
        license: values.image?.license || ''
    };

    return (
        <css.section>
            <ImageHeader text={'subscriptionImageText'} height={500} width={500} />
            <css.imageWrapper data-cy={'subscriptionImage'}>
                {!values.image && <css.image className={type} image={defaultFallbackImage} />}
                <ExternalImagePopup 
                    imageProps={imageEditorProps} 
                    creditProps={creditProps} 
                    absoluteImage={!values.image}
                />
            </css.imageWrapper>
            
            <css.editorWrapper data-cy="subscriptionDescriptionEditor">
            <css.sectionHeader>
                <css.headerTitle>{t('subscriptionDescriptionTitle')}</css.headerTitle>
                <p>{t('subscriptionDescriptionSubtitle')}</p>
            </css.sectionHeader>
                <css.editorTitle>{t('freeText')}</css.editorTitle>
                <TextEditor
                    showToolbar={true}
                    expanded={true}
                    defaultText={values.description || ''}
                    lang={lang}
                    quillRef={quillRef}
                    onChange={undefined}
                    minHeight="300px"
                    onSave={(html) => {
                        setFieldValue('description', html);
                    }}
                    variablesType='series'
                    variablesDataCy='subscription-series-create-variables-dropdown'
                    placeholder={t('freeTextPlaceholder')}
                    limit={{showCharCounter:true, maxChar:2000}}
                />
            </css.editorWrapper>
        </css.section>
    );
}

export default DetailsStep;

